import React from "react";
import Attachment from "./Attachment";
import { Button, ProgressBar, Tooltip } from "@fluentui/react-components";
import Workspace from "./Workspace";
import FullPageLoader from "../../../components/loaders/FullPageLoader";
import useAppContext from "../../../hooks/useAppContext";
import EmptyAttachments from "./EmptyAttachments";
import { saveBtnClass, stackColumnGap20, stackColumnGap10Pad20, paddingBottom10, followBtnClass, cardClass } from "./styles";
import SavedAttachments from "./SavedAttachments/SavedAttachments";
import useAuthContext from "../../../hooks/useAuthContext";
import { NO_DOC_MANAGEMENT } from "../../../config";
import useOfficeContext from "../../../hooks/useOfficeContext";
import { followConversation, unfollowByMessage } from "../../../api/follow";
import { wrapperClasses } from "./Attachment/style";
import { useMutation } from "@tanstack/react-query";
import { useAppInsightsContext } from "@microsoft/applicationinsights-react-js";
import { MailAddRegular, ArrowUndoRegular } from "@fluentui/react-icons";

const MessageAnalysis: React.FC = () => {
  const {
    attachments,
    attachmentsComparison,
    savedAttachments,
    savedAttachmentsComparison,
    workspaceName,
    initialLoading,
    isSaving,
    isFollowed,
    onSavePress,
  } = useAppContext();

  const { itemIds } = useOfficeContext();
  const { appInfo, tokenData } = useAuthContext();
  const msUserId = tokenData.oid;
  const appInsights = useAppInsightsContext();

  // v5: Changed from useMutation(fn) to useMutation({ mutationFn })
  const followMutation = useMutation({
    mutationFn: async () => followConversation(msUserId, itemIds),
  });

  // v5: Changed from useMutation(fn) to useMutation({ mutationFn })
  const unfollowMutation = useMutation({
    mutationFn: async () => unfollowByMessage(msUserId, itemIds),
  });

  let showHideFollow;
  isFollowed ? (showHideFollow = false) : (showHideFollow = true);
  //to do use isFollowed to conditionaly show buttons for multiselect -need appcontext to get array of message properties)
  const multiSelect = (
    <div>
      <div className={cardClass}>
        <div className={stackColumnGap10Pad20}>
          <div>
            {showHideFollow && (
              <>
                <Tooltip content="Follow all the selected conversations" relationship="description" positioning="below">
                  <Button
                    className={followBtnClass}
                    icon={<MailAddRegular />}
                    onClick={() => { followMutation.mutate(); appInsights.trackEvent({ name: "Button click: Follow" }); }}
                    disabled={followMutation.isPending}
                  >
                    Follow selected
                  </Button>
                </Tooltip>
                {/* v5: Use isPending instead of isLoading */}
                {followMutation.isPending && <ProgressBar />}
              </>
            )}
            {!showHideFollow && (
              <>
                <Tooltip content="Unfollow all the selected conversations" relationship="description" positioning="below">
                  <Button
                    className={followBtnClass}
                    icon={<ArrowUndoRegular />}
                    onClick={() => { unfollowMutation.mutate(); appInsights.trackEvent({ name: "Button click: Unfollow" }); }}
                    disabled={unfollowMutation.isPending}
                  >
                    Unfollow selected
                  </Button>
                </Tooltip>
                {/* v5: Use isPending instead of isLoading */}
                {unfollowMutation.isPending && <ProgressBar />}
              </>
            )}

          </div>
        </div>
      </div>
    </div>
  );

  return (
    <div>
      {initialLoading && itemIds.length === 1 ? (
        <FullPageLoader title="Analysis loading..." />
      ) : (
        <div className={paddingBottom10}>
          {attachments.length > 0 || savedAttachments.length > 0 || attachmentsComparison.length > 0 ? (
            <div>
              {appInfo.documentManagement !== NO_DOC_MANAGEMENT && <Workspace workspaceName={workspaceName} />}
              <div className={stackColumnGap20}>
                {(attachments.length > 0 || attachmentsComparison.length > 0) && (
                  <div className={paddingBottom10}>
                    <div className={stackColumnGap20}>
                      {attachmentsComparison.map((attachment) => (
                        <Attachment attachment={attachment} key={attachment.attachmentId} />
                      ))}
                      {attachments.map((attachment) => (
                        <Attachment attachment={attachment} key={attachment.attachmentId} />
                      ))}
                      {isSaving && <ProgressBar />}
                      {appInfo.documentManagement !== NO_DOC_MANAGEMENT && (
                        <Button appearance="primary" disabled={isSaving} onClick={onSavePress} className={saveBtnClass}>
                          Save
                        </Button>
                      )}
                    </div>
                  </div>
                )}
                {appInfo.documentManagement !== NO_DOC_MANAGEMENT &&
                  (savedAttachments.length > 0 || savedAttachmentsComparison.length > 0) ? (
                  <SavedAttachments />
                ) : null}
              </div>
            </div>
          ) : itemIds.length > 1 ? (
            multiSelect
          ) : (
            <EmptyAttachments />
          )}
        </div>
      )}
    </div>
  );
};

export default MessageAnalysis;
